<template>
    <div>
        <div class="acc">
            <img src="../../assets/images/acc1.png" alt="">
            <img class="tab" @click="open('https://mp.weixin.qq.com/s/OmzTaGQrctVBgdSsExiCaw')" src="../../assets/images/acc2.png" alt="">
            <img class="tab" @click="open('https://mp.weixin.qq.com/s/wwZL2YVIQPutOhZXL1bmcA')" src="../../assets/images/acc3.png" alt="">
            <img class="tab" @click="open('https://mp.weixin.qq.com/s/ZaZnkwLFvrZlqVaAvzydAg')" src="../../assets/images/acc4.png" alt="">
            <img class="tab" @click="open('https://mp.weixin.qq.com/s/SVXkyF6jaU6aaXps1V0ZEg')" src="../../assets/images/acc5.png" alt="">
            <img src="../../assets/images/acc6.png" alt="">
            <img class="tab" @click="open('https://mp.weixin.qq.com/s/Dv3GUfLolIUYRZxkMmH4kQ')" src="../../assets/images/acc7.png" alt="">
            <img class="tab" @click="open('https://mp.weixin.qq.com/s/wyH3XG8Cs0OvKTV2U0q_2w')" src="../../assets/images/acc8.png" alt="">
            <img class="tab" @click="open('https://mp.weixin.qq.com/s/hSJmmGHp8L6FAd3l9V8LaA')" src="../../assets/images/acc9.png" alt="">
            <img class="tab" @click="open('https://mp.weixin.qq.com/s/Vvp78ZspjgsAjFHrvtjvLg')" src="../../assets/images/acc10.png" alt="">
            <img src="../../assets/images/acc11.png" alt="">
            <img class="tab" @click="$router.push('/integral')" src="../../assets/images/acc12.png" alt="">
            <img src="../../assets/images/acc13.png" alt="">
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
        }
    },
    computed: {
    },
    methods: {
        open(url) {
            window.open(url)
        }
    }
}
</script>

<style lang="scss" scoped>
.tab {
    cursor: pointer;
}
.acc {
    width: 1365px;
    // height: 4287px;
    margin: 0 auto;
    margin-top: 46px;
    img {
        margin: 0;
        display: block;
        padding: 0;
        width: 100%;
        object-fit: cover;
    }
    // background: url('../../assets/images/acc-bg.png') no-repeat;
    // background-size: 100% cover;
}
</style>
